import React, { type ReactElement, memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { overquota256TariffId } from 'reactApp/appHelpers/featuresHelpers/features/overquotaPre';
import { PaymentUTM } from 'reactApp/constants/paymentUTM';
import { sendDwhBanner } from 'reactApp/modules/dwh/dwh.helpers';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { updateProducts } from 'reactApp/modules/products/products.module';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { historyPush } from 'reactApp/modules/router/router.module';
import type { RootState } from 'reactApp/store';
import { InformationAlertBanner } from 'reactApp/ui/InformationAlertBanner/InformationAlertBanner';

const name = 'mnz_avoid_overquota';

export const PreOverquotaBanner = memo(function PreOverquotaBanner(): ReactElement | null {
    const dispatch = useDispatch();
    const productId = overquota256TariffId;
    const product = useSelector((state: RootState) => ProductsSelectors.getProductById(state, productId));

    useEffect(() => {
        if (!productId || product) {
            return;
        }

        dispatch(updateProducts({ productId }));
    }, [productId, product]);

    useEffect(() => {
        sendDwhBanner({ action: 'view', name });
    }, []);

    const onPrimaryHandler = useCallback(() => {
        sendDwhBanner({ action: 'click-tariff', name });

        dispatch(
            openTariffBuy({
                productId,
                isMobile: IS_PHONE_BROWSER,
                paySource: getPaySource(`avoid_overquota_banner`),
            })
        );
    }, [productId]);

    const onSecondaryHandler = useCallback(() => {
        sendDwhBanner({ action: 'click', name, button_name: 'other_tariffs' });

        dispatch(
            historyPush({
                id: '/promo/quota',
                search: `?${PaymentUTM.preOverquota}`,
                hash: 'tariffs',
            })
        );
    }, []);

    return (
        <InformationAlertBanner
            title="Скоро в Почте и Облаке могут начаться ограничения — как избежать"
            // eslint-disable-next-line no-irregular-whitespace
            content={`Увеличьте на ${product?.space?.value || ''} с подпиской Mail Space, не будет ограничений на отправку и хранение`}
            // eslint-disable-next-line no-irregular-whitespace
            primaryButtonTitle={`Добавить ${product?.space?.value || ''} `}
            secondaryButtonTitle="Другие тарифы"
            onPrimaryClick={onPrimaryHandler}
            onSecondaryClick={onSecondaryHandler}
        />
    );
});
